import customAxios from "../../customAxios";
import { VERIFY_CODE } from "../../routes";

interface iVerifyCode {
  verificationCode: string;
  phoneNumber: string;
  userType: any;
}

const verifyCode = async ({
  phoneNumber,
  verificationCode,
  userType,
}: iVerifyCode) => {
  let loginData: any = null;
  try {
    const request = await customAxios.post(VERIFY_CODE, {
      phoneNumber,
      verificationCode,
      populate: "companyInformation.city provinceEducationInformation.province",
    });

    const tokens = request.data.result.user.tokens;
    // a company operator logs in for its company: the backend returns that company in `result.company`, and the
    // panel must use the company's id / balance / documents (they are sent back as the company in later requests)
    const account = request.data.result.company ?? request.data.result.user;
    tokens.map((token: any) => {
      if (token.userType === userType)
        loginData = {
          token: token.token,
          userType,
          userId: account._id,
          fullName:
            request.data.result.user.firstName +
            " " +
            request.data.result.user.lastName,
          avatar: request.data.result.user.avatar,
          balance: account.balance,
          city: request.data.result.city,
          permission: request.data.result.user.permission,
          isPrimary: request.data.result.user.isPrimary,
          province:
            userType === "PROVINCE_EDUCATION" &&
            request.data.result.user.provinceEducationInformation.province,
          documents: account.companyInformation?.documents,
          walletBalance: account.balance,
          profitBalance:
            account.companyInformation?.profitBalance,
        };
      return false;
    });
    return loginData;
  } catch (error) {
    return "error";
  }
};

export default verifyCode;
